
import { Navigate } from "react-router";
import { useEffect, type JSX } from "react";
import { useForm } from "react-hook-form"
import { FloatingInputBootStrap, FloatingTextareaBootstrap } from "../Common/FloatingInputBootstrap";
import { useAddMetasMutation } from "../../stores/OkOkStore";
import type { ResponseError } from "../../types/CommonReponse";
import type { MetasInsert } from "../../types/Metas";
import { useTrads } from "../../contexts/trads/useTrads";

export function  MetasInsertForm (): JSX.Element {
    const  metas:MetasInsert={name:"",value:"",explication:"",type:"",type_info:""};
    const [addMetas,result]=useAddMetasMutation();
    const { register, handleSubmit,setError, formState: { errors } } = useForm({
        defaultValues:metas,
        //shouldUseNativeValidation: true,
        mode:'onBlur',
    });
    const {translate}=useTrads();
    
    useEffect(()=>{
        if(result.error && 'data' in result.error) {
            const server_error:ResponseError=result.error as ResponseError;
            const errors =server_error.data.error;
            if(errors){
                for (const i in errors) {
                        // @ts-expect-error i est connu!
                        setError(i, {type:'validate',message: translate(errors[i])});  
                }
                result.reset();
            }
        }
    },[setError,result,translate]);
    
    return (
        result.isSuccess ? <Navigate to={`/metas/${result.data.id.toString()}`} state={{"modified":true}}></Navigate>  :(
        result.error ? <p className="p-3 mb-2 bg-danger text-white">{translate('page_load_error')}</p> :
        result.isLoading ? <p className="p-3 mb-2 bg-info text-white">{translate('page_loading')}</p> :
        <form className="row" onSubmit={(event) => void handleSubmit(addMetas)(event)}>
            <div className="col-12  mb-3">
                <FloatingInputBootStrap
                    name="name"
                    label={translate('meta_name')}
                    type="text"
                    errors={errors}
                    registerOutput= {register("name", {
                        required: translate("meta_error_name_requis"),
                        minLength: 2
                    })} 
                />

            </div>
             
            <div className="col-12  mb-3">
                <FloatingTextareaBootstrap
                    name="value"
                    label={translate('meta_value')}
                    type="text"
                    errors={errors}
                    registerOutput= {register("value", {
                        required: translate('meta_error_name_requis'),
                        
                    })} 
                />

            </div>    

            <div className="col-12  mb-3">
                <FloatingTextareaBootstrap
                    name="explication"
                    label={translate('meta_explication')}
                    type="text"
                    errors={errors}
                    registerOutput= {register("explication")} 
                />

            </div>


            <div className="col-12  mb-3">
                <button type="submit">{translate('form_submit')}</button>
            </div>
        </form>
        )
    )
};

export default MetasInsertForm;

